module.exports = __webpack_public_path__ + "static/img/apex.6543aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/discord/apex.png
// module id = rfO+
// module chunks = 35